var map = {
	"./Logo.svg": 13130,
	"./clients-financial.svg": 33060,
	"./clients-quick.svg": 86231,
	"./clients-sales-orders-trips.svg": 7251,
	"./clients-sales-trips.svg": 9533,
	"./clients-sales.svg": 25274,
	"./driver-1.svg": 73235,
	"./driver-car-empty.svg": 20976,
	"./driver-popup-vehicle.svg": 11059,
	"./driver-triangl.svg": 48409,
	"./drivers-quick.svg": 7102,
	"./icons/Expand-all.svg": 8900,
	"./icons/Group.svg": 99547,
	"./icons/LogOut.svg": 18408,
	"./icons/Popup-question.svg": 97977,
	"./icons/Radio.svg": 11839,
	"./icons/Reservation.svg": 28632,
	"./icons/accident-button.svg": 25646,
	"./icons/accordian-icon.svg": 74760,
	"./icons/add-icon.svg": 98043,
	"./icons/alert-circle.svg": 36777,
	"./icons/alert-triangle-icon.svg": 32481,
	"./icons/ap-ar-dark.svg": 36556,
	"./icons/ap-ar.svg": 94423,
	"./icons/approval -popup.svg": 37168,
	"./icons/approve-icon.svg": 37097,
	"./icons/archive-icon.svg": 14670,
	"./icons/arrow-curve-left-up.svg": 99779,
	"./icons/arrow-down-light.svg": 8229,
	"./icons/arrow-down.svg": 30222,
	"./icons/arrow-icon.svg": 70021,
	"./icons/arrow-refresh-icon.svg": 82191,
	"./icons/arrow-right.svg": 91720,
	"./icons/arrows-up.svg": 40734,
	"./icons/bank.svg": 91832,
	"./icons/bell.svg": 47185,
	"./icons/branch-icon.svg": 77028,
	"./icons/bread_crumb.svg": 64364,
	"./icons/bread_crumb_double.svg": 62180,
	"./icons/calendar-01.svg": 98188,
	"./icons/calendar-03.svg": 48782,
	"./icons/calendar-icon.svg": 7522,
	"./icons/calendar.svg": 81072,
	"./icons/car-icon.svg": 61762,
	"./icons/change-status.svg": 47533,
	"./icons/charter-icon.svg": 25139,
	"./icons/check-black-icon.svg": 67578,
	"./icons/check-broken.svg": 7788,
	"./icons/check-icon.svg": 90052,
	"./icons/chevron-down-blue.svg": 28817,
	"./icons/chevron-down.svg": 66688,
	"./icons/chevron.svg": 29067,
	"./icons/client-dark.svg": 76508,
	"./icons/client-edit.svg": 22404,
	"./icons/client-info-icon.svg": 17918,
	"./icons/client.svg": 16487,
	"./icons/clock-1-icon.svg": 7176,
	"./icons/clock-2-icon.svg": 29729,
	"./icons/clock-icon.svg": 47666,
	"./icons/clock.svg": 95904,
	"./icons/close-icon.svg": 2464,
	"./icons/closed-popup.svg": 25351,
	"./icons/column-vertical.svg": 5479,
	"./icons/company-detail.svg": 35171,
	"./icons/company-details.svg": 5514,
	"./icons/company-profile-dark.svg": 94492,
	"./icons/company-profile.svg": 72967,
	"./icons/confirm-with-note-icon.svg": 74926,
	"./icons/contract-icon-dark.svg": 42871,
	"./icons/contract-icon.svg": 88526,
	"./icons/cross-icon-light.svg": 23151,
	"./icons/cross-icon.svg": 61719,
	"./icons/cycle-icon.svg": 53746,
	"./icons/dashboard-dark.svg": 45547,
	"./icons/dashboard.svg": 99274,
	"./icons/delete-category.svg": 34420,
	"./icons/download-02.svg": 20001,
	"./icons/download-icon.svg": 45804,
	"./icons/driver-edit.svg": 96841,
	"./icons/driver-info-icon.svg": 92501,
	"./icons/driver-picture-dummy-1.svg": 63704,
	"./icons/driver-picture-dummy.svg": 51754,
	"./icons/driver-remove-x.svg": 29850,
	"./icons/driver-vehicle.svg": 13607,
	"./icons/dry-clean-button.svg": 61046,
	"./icons/edit-button.svg": 75987,
	"./icons/edit-panicle.svg": 23085,
	"./icons/edit-pen-custom.svg": 6748,
	"./icons/edit-pen.svg": 22040,
	"./icons/escalation.svg": 3121,
	"./icons/excel-icon.svg": 77615,
	"./icons/exclamation-mark.svg": 64549,
	"./icons/export-icon.svg": 26886,
	"./icons/file-1-icon.svg": 8304,
	"./icons/file-attach.svg": 39110,
	"./icons/file-icon.svg": 78026,
	"./icons/finance-icon-dark.svg": 57763,
	"./icons/finance-icon.svg": 32402,
	"./icons/form-builder.svg": 66546,
	"./icons/funnel-simple.svg": 36097,
	"./icons/grid-icon.svg": 66924,
	"./icons/image-icon.svg": 6197,
	"./icons/image-placeholder.svg": 57581,
	"./icons/information-circle-blue.svg": 64762,
	"./icons/insurance-button.svg": 83371,
	"./icons/license-renewal-button.svg": 49729,
	"./icons/list-icon.svg": 71680,
	"./icons/location-icon.svg": 34723,
	"./icons/maintenance-Button.svg": 91728,
	"./icons/maintenance-vector.svg": 62993,
	"./icons/management-system.svg": 94227,
	"./icons/map.svg": 9352,
	"./icons/message-square.svg": 83917,
	"./icons/messaging-center-icon-light.svg": 75721,
	"./icons/messaging-center-icon.svg": 15410,
	"./icons/minus-circle-contained.svg": 17695,
	"./icons/mobile-map-dropoff-marker.svg": 88959,
	"./icons/mobile-map-pickup-marker.svg": 49045,
	"./icons/more-details.svg": 98652,
	"./icons/move.svg": 79993,
	"./icons/my-profile-dark.svg": 17717,
	"./icons/my-profile.svg": 3080,
	"./icons/new-list-icon.svg": 85929,
	"./icons/operations.svg": 6064,
	"./icons/paperclip-files.svg": 22604,
	"./icons/pdf-icon.svg": 88902,
	"./icons/person-vector.svg": 9323,
	"./icons/phone-call.svg": 88231,
	"./icons/pin-marker.svg": 94222,
	"./icons/pincle-edit-light.svg": 84175,
	"./icons/pincle-edit.svg": 86276,
	"./icons/placeholder-add.svg": 86915,
	"./icons/placeholder-location.svg": 16363,
	"./icons/plus-danger.svg": 26946,
	"./icons/plus-icon.svg": 26024,
	"./icons/plus-secondary.svg": 30419,
	"./icons/plus-white.svg": 70586,
	"./icons/plus.svg": 68718,
	"./icons/popup-cancel-icon.svg": 40071,
	"./icons/popup-close.svg": 49599,
	"./icons/popup-info-wide-icon.svg": 34592,
	"./icons/popup-success-icon-new.svg": 5213,
	"./icons/popup-success-icon.svg": 35288,
	"./icons/popup-warning-icon.svg": 12391,
	"./icons/printer.svg": 65006,
	"./icons/privacy-page/auto-conversations.svg": 4431,
	"./icons/privacy-page/call.svg": 59797,
	"./icons/privacy-page/check.svg": 20851,
	"./icons/privacy-page/clock.svg": 5361,
	"./icons/privacy-page/db.svg": 36619,
	"./icons/privacy-page/email.svg": 20223,
	"./icons/privacy-page/list-one.svg": 78426,
	"./icons/privacy-page/list-two.svg": 13892,
	"./icons/privacy-page/security-check.svg": 11116,
	"./icons/privacy-page/shield.svg": 71874,
	"./icons/privacy-page/user-list.svg": 62705,
	"./icons/recurrence-icon.svg": 4502,
	"./icons/rejected-icon.svg": 18694,
	"./icons/renewal-Button.svg": 17031,
	"./icons/requests-icon-dark.svg": 60755,
	"./icons/requests-icon.svg": 9026,
	"./icons/returned-icon.svg": 69047,
	"./icons/sales-icon-dark.svg": 29277,
	"./icons/sales-icon-light.svg": 80107,
	"./icons/search-bar-icon.svg": 32700,
	"./icons/search-color-icon.svg": 13934,
	"./icons/search-icon.svg": 44164,
	"./icons/select-time.svg": 92664,
	"./icons/setting-icon-dark.svg": 20589,
	"./icons/setting-icon-light.svg": 78491,
	"./icons/setting-icon.svg": 79280,
	"./icons/shift-recurring-icon.svg": 12182,
	"./icons/small-face-dark.svg": 36712,
	"./icons/small-face.svg": 48507,
	"./icons/small-truck.svg": 56561,
	"./icons/sort-ascending.svg": 57663,
	"./icons/sort-descending.svg": 38949,
	"./icons/star.svg": 35034,
	"./icons/start-marker.svg": 40937,
	"./icons/step-shape.svg": 48620,
	"./icons/switch-dark.svg": 18595,
	"./icons/switch-outline.svg": 26123,
	"./icons/system-management-dark.svg": 57900,
	"./icons/tanker2.svg": 92947,
	"./icons/ticket-button.svg": 57483,
	"./icons/ticket-timer.svg": 76830,
	"./icons/tickets-person.svg": 4189,
	"./icons/tickets-timer-circle.svg": 68414,
	"./icons/transfer-button.svg": 58668,
	"./icons/trash-icon-red.svg": 14460,
	"./icons/trash-icon.svg": 13158,
	"./icons/trash-light-new.svg": 19314,
	"./icons/trash-red-icon.svg": 36048,
	"./icons/truck-icon.svg": 83551,
	"./icons/trush-light.svg": 83523,
	"./icons/trush.svg": 19320,
	"./icons/upload-icon.svg": 1621,
	"./icons/user-icon.svg": 45279,
	"./icons/user-profile.svg": 86251,
	"./icons/vehicle-picture-dummy.svg": 71368,
	"./icons/warning-alert.svg": 81451,
	"./icons/x-circle-contained.svg": 90503,
	"./login-header.svg": 14124,
	"./manage-quick.svg": 38556,
	"./reservations-quick.svg": 49412,
	"./universal.svg": 47290,
	"./vehicle-quick.svg": 51151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;